// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from '../../../../menu-items';
import useAuth from 'routes/Hooks/useAuth';

import dashboard from '../../../../menu-items/dashboard';
import utilities from '../../../../menu-items/utilities';
import other from '../../../../menu-items/other';
import pages from "../../../../menu-items/pages"
import ReceiptIcon from '@mui/icons-material/Receipt';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import FactCheckIcon from '@mui/icons-material/FactCheck';

const utilities2 = {
    id: 'Lists',
    title: 'Lists',
    type: 'group',
    children: [
        {
            id: 'EssayList',
            title: 'Essay List',
            type: 'item',
            url: '/MyHussain/EssayList',
            icon: FactCheckIcon,
            breadcrumbs: false
        },
        {
            id: 'QuizList',
            title: 'Quiz List',
            type: 'item',
            url: '/MyHussain/QuizList',
            icon: FactCheckIcon,
            breadcrumbs: false
        },

    ]
};

const utilities3 = {
    id: 'Operations',
    title: 'Operations',
    type: 'group',
    children: [
        {
            id: 'Essay List',
            title: 'Essay List',
            type: 'item',
            url: '/MyHussain/TeacherEssayList',
            icon: ReceiptIcon,
            breadcrumbs: false
        },
        
    ]
};


const MenuList = () => {

    let { auth } = useAuth()
    let UserType = auth?.User?.usertype

    const menuItemsNew2 = {
        items: [pages, dashboard, utilities2, other]
    };

    const menuItemsNew = {
        items: [pages, dashboard, utilities, utilities2, other]
    };
    const menuItemsNew3 = {
        items: [pages, dashboard,  utilities3, other]
    };


    let navItems;

    console.log("UserType", UserType)

    UserType == "Admin" ?

        navItems = menuItemsNew.items.map((item) => {

            switch (item.type) {
                case 'group':
                    return <NavGroup key={item.id} item={item} />;
                default:
                    return (
                        <Typography key={item.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
            }

        })
        : UserType == "Teacher" ?

            navItems = menuItemsNew3.items.map((item) => {

                switch (item.type) {
                    case 'group':
                        return <NavGroup key={item.id} item={item} />;
                    default:
                        return (
                            <Typography key={item.id} variant="h6" color="error" align="center">
                                Menu Items Error
                            </Typography>
                        );
                }

            })

            :
            navItems = menuItemsNew2.items.map((item) => {

                switch (item.type) {
                    case 'group':
                        return <NavGroup key={item.id} item={item} />;
                    default:
                        return (
                            <Typography key={item.id} variant="h6" color="error" align="center">
                                Menu Items Error
                            </Typography>
                        );
                }

            })



    return <>{navItems}</>;
};

export default MenuList;
